module.exports = __webpack_public_path__ + "img/yu.6e8fa2bf.png";